'use client'
import React, { useState } from 'react'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const ContentToggler = (props) => {
    const { children, className, ...rest } = props;
    const [open, setOpen] = useState(false)
    return (
        <>
            <div className={`overflow-hidden duration-300 transition-all	mb-4 relative  ${open ? "max-h-[2000px]" : " max-h-20"}`}>
                {children}
                {!open && <div className="absolute bottom-0 left-0 right-0 h-20 z-10 bg-gradient-to-t from-white via-white/80 to-white/0"></div>}
            </div>
            <button className="text-primary flex items-center gap-1" onClick={() => setOpen(!open)}>
                {open ? "Show less " : "Show more"}
                {open ? <ExpandLessIcon className="!text-[1.25rem]" /> : <ExpandMoreIcon className="!text-[1.25rem]" />}
            </button>
        </>

    )
};

export default ContentToggler;




